import { render, staticRenderFns } from "./ImageSampleNew.vue?vue&type=template&id=7ffe65df&scoped=true"
import script from "./ImageSampleNew.vue?vue&type=script&lang=ts"
export * from "./ImageSampleNew.vue?vue&type=script&lang=ts"
import style0 from "./ImageSampleNew.vue?vue&type=style&index=0&id=7ffe65df&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe65df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffe65df')) {
      api.createRecord('7ffe65df', component.options)
    } else {
      api.reload('7ffe65df', component.options)
    }
    module.hot.accept("./ImageSampleNew.vue?vue&type=template&id=7ffe65df&scoped=true", function () {
      api.rerender('7ffe65df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ImageSampleNew.vue"
export default component.exports